import callCenterService from '../services/callCenterService';

export const SET_CALL_CENTERS = '@types/set-call-centers';

export function setCallCenters(user, existingReduxCallCenters) {
  if (existingReduxCallCenters) {
    return (dispatch) => {
      dispatch({
        type: SET_CALL_CENTERS,
        payload: {
          callCenters: existingReduxCallCenters,
        }
      });
    };
  }
  const request = callCenterService.getCallCenters(user);
  return (dispatch) => {
    request.then((response) => dispatch({
      type: SET_CALL_CENTERS,
      payload: response?.data
    }));
  };
}
